import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { class: "wrap" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "logo-container" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "tabbar-container" }

import TabBar from "./components/TabBar.vue";
import { oss } from "./utils/oss";
import { onMounted, onBeforeUnmount } from 'vue';
import autofit from 'autofit.js';

export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

onMounted(() => {
  autofit.init({
        dh: 1080,
        dw: 1920,
        resize: true
    })


});


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _directive_reveal = _resolveDirective("reveal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          class: "imgUrl",
          src: _unref(oss)('logo.png'),
          alt: "启愉智能 INSPIRER"
        }, null, 8, _hoisted_4)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(TabBar)
      ])
    ])), [
      [_directive_reveal]
    ]),
    _createVNode(_component_router_view)
  ]))
}
}

})